<template>
    <div class="main">
        <c-panel title="SIMULADOR DE FÓRMULA DE CÁLCULO" titleIcon="fas fa-flask">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="A simulação é feita pelo próprio motor de cálculo do sistema. Nada é gravado: não cria nota, não altera turma e não vincula a fórmula a ninguém."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Fórmula">
                            <el-select v-model="formulaId" style="width: 100%;" filterable clearable
                                :placeholder="avulsa ? 'Configuração da tela (não salva)' : 'Sem fórmula — comportamento atual do sistema'"
                                :disabled="!!avulsa" @change="simular">
                                <el-option v-for="f in formulas" :key="f.id" :value="f.id" :label="f.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Qtd. de períodos">
                            <el-input v-model="qtdPeriodos" v-mask="'##'" @change="simular"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Frequência (%)">
                            <el-input v-model="frequencia" v-mask="'###'" placeholder="opcional" @change="simular"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" class="u-text-right" style="padding-top: 30px;">
                        <el-button type="primary" @click="simular">SIMULAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="avulsa" type="warning" :closable="false" class="u-mb-15"
                title="Simulando a configuração que está aberta no formulário, ainda não salva."></el-alert>

            <h4>Notas de entrada</h4>
            <div class="container-table u-mb-20">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 120px;">Período</th>
                            <th>Avaliações</th>
                            <th style="width: 160px;">Recuperação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="p in periodos" :key="p.numero">
                            <td>{{ p.numero }}º período</td>
                            <td>
                                <el-row :gutter="6">
                                    <el-col :xs="8" :sm="3" v-for="(a, i) in p.avaliacoes" :key="i">
                                        <el-input v-model="p.avaliacoes[i]" v-mask="'##,##'" size="mini"></el-input>
                                    </el-col>
                                    <el-col :xs="8" :sm="3">
                                        <el-button size="mini" icon="el-icon-plus" @click="p.avaliacoes.push('')" plain></el-button>
                                        <el-button class="u-ml-10" size="mini" icon="el-icon-minus" @click="p.avaliacoes.pop()" plain v-if="p.avaliacoes.length > 1"></el-button>
                                    </el-col>
                                </el-row>
                            </td>
                            <td><el-input v-model="p.recuperacao" v-mask="'##,##'" size="mini" placeholder="—"></el-input></td>
                        </tr>
                        <tr>
                            <td colspan="2" class="u-text-right"><strong>Exame final da disciplina</strong></td>
                            <td><el-input v-model="exame" v-mask="'##,##'" size="mini" placeholder="—"></el-input></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <template v-if="resultado">
                <h4>Configuração utilizada</h4>
                <div class="container-table u-mb-20">
                    <table class="table table-striped">
                        <tbody>
                            <tr><td style="width: 240px;">Média do período</td><td>{{ resultado.configuracao.metodo_periodo }}</td></tr>
                            <tr><td>Média anual</td><td>{{ resultado.configuracao.metodo_anual }}</td></tr>
                            <tr><td>Recuperação</td><td>{{ resultado.configuracao.tratamento_recuperacao }}</td></tr>
                            <tr><td>Exame final</td><td>{{ resultado.configuracao.tratamento_exame_final }}</td></tr>
                            <tr><td>Arredondamento</td><td>{{ resultado.configuracao.arredondamento }} ({{ resultado.configuracao.casas_decimais }} casas)</td></tr>
                            <tr><td>Média de aprovação</td><td>{{ resultado.configuracao.media_aprovacao }}</td></tr>
                            <tr><td>Períodos considerados</td><td>{{ resultado.qtd_periodos }}</td></tr>
                        </tbody>
                    </table>
                </div>

                <h4>Resultado</h4>
                <div class="container-table" v-for="(d, disc) in resultado.disciplinas" :key="disc">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 130px;">Período</th>
                                <th class="u-text-center">Resultado do período</th>
                                <th class="u-text-center">Recuperação</th>
                                <th class="u-text-center">Valor aplicado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(p, k) in d.periodos" :key="k">
                                <td>{{ k }}º período</td>
                                <td class="u-text-center">{{ p.m.v }}</td>
                                <td class="u-text-center">{{ p.recuperacao === null || p.recuperacao === '' ? '—' : p.recuperacao }}</td>
                                <td class="u-text-center">{{ p.aplicado }}</td>
                            </tr>
                            <tr>
                                <td colspan="3" class="u-text-right"><strong>Média parcial</strong></td>
                                <td class="u-text-center"><strong>{{ d.m_parcial }}</strong></td>
                            </tr>
                            <tr>
                                <td colspan="3" class="u-text-right"><strong>Média final</strong> <span v-if="d.houve_exame">(após exame)</span></td>
                                <td class="u-text-center"><strong>{{ d.m_final }}</strong></td>
                            </tr>
                            <tr>
                                <td colspan="3" class="u-text-right"><strong>Situação</strong></td>
                                <td class="u-text-center" style="text-transform: uppercase;">
                                    <el-tag :type="d.situacao === 'aprovado' ? 'success' : 'danger'" size="mini">{{ d.situacao }}</el-tag>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>

            <el-row class="u-mt-15">
                <el-col :xs="24" class="u-text-right">
                    <router-link to="/admin/formula-calculo"><el-button>VOLTAR</el-button></router-link>
                </el-col>
            </el-row>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        formulas: [],
        formulaId: '',
        avulsa: null,
        qtdPeriodos: '3',
        frequencia: '',
        exame: '',
        periodos: [
            { numero: 1, avaliacoes: ['2', '3'], recuperacao: '' },
            { numero: 2, avaliacoes: ['4', '4'], recuperacao: '' },
            { numero: 3, avaliacoes: ['1', '1'], recuperacao: '' }
        ],
        resultado: null
    }),
    mounted () {
        if (this.$route.query.avulsa) {
            try { this.avulsa = JSON.parse(this.$route.query.avulsa) } catch (e) { this.avulsa = null }
        }
        if (this.$route.params.id) this.formulaId = Number(this.$route.params.id)
        this.$axios.get(
            `${this.$store.state.config.baseUrlApi}/api/formula-calculo/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.formulas = r.data || []; this.simular() })
         .catch(e => this.$store.commit('throwException', e))
    },
    methods: {
        // Monta `periodos` no mesmo formato de notas.atividades usado pela API.
        montarEntrada () {
            const p = {}
            this.periodos.forEach(per => {
                const bloco = {}
                per.avaliacoes.forEach((v, i) => { bloco['a' + i] = { u: '', v: v === '' ? '' : String(v).replace(',', '.') } })
                bloco.r = { u: '', v: per.recuperacao === '' ? '' : String(per.recuperacao).replace(',', '.') }
                p[String(per.numero)] = bloco
            })
            if (this.exame !== '') p.r = { u: '', v: String(this.exame).replace(',', '.') }
            return p
        },
        simular () {
            const payload = { periodos: this.montarEntrada(), qtd_periodos: Number(this.qtdPeriodos) || 1 }
            if (this.avulsa) payload.formula = this.avulsa
            else if (this.formulaId) payload.formula_calculo_id = this.formulaId
            if (this.frequencia !== '') payload.frequencia_percentual = Number(this.frequencia)

            window.eventBus.$emit('loading', true)
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/formula-calculo/simular`,
                payload,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    this.resultado = null
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.resultado = r.data
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
